import { render, staticRenderFns } from "./setDialog.vue?vue&type=template&id=4084a6c7&scoped=true&"
import script from "./setDialog.vue?vue&type=script&lang=js&"
export * from "./setDialog.vue?vue&type=script&lang=js&"
import style0 from "./setDialog.vue?vue&type=style&index=0&id=4084a6c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4084a6c7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4084a6c7')) {
      api.createRecord('4084a6c7', component.options)
    } else {
      api.reload('4084a6c7', component.options)
    }
    module.hot.accept("./setDialog.vue?vue&type=template&id=4084a6c7&scoped=true&", function () {
      api.rerender('4084a6c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/audit/category/setDialog.vue"
export default component.exports